/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Readmore2Inputs */

const id_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baca selengkapnya`)
};

const ms_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baca lagi`)
};

const da_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Læs mere`)
};

const de_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiterlesen`)
};

const en_us2_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read more`)
};

const es_es2_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer más`)
};

const es_mx2_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer más`)
};

const fil_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magbasa pa`)
};

const fr_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lire la suite`)
};

const it_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leggi tutto`)
};

const hu_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bővebben`)
};

const nl_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lees meer`)
};

const no_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les mer`)
};

const pl_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czytaj więcej`)
};

const pt_br2_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leia mais`)
};

const pt_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ler mais`)
};

const ro_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Citește mai mult`)
};

const fi_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lue lisää`)
};

const sv_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läs mer`)
};

const vi_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đọc thêm`)
};

const tr_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devamını oku`)
};

const cs_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Číst více`)
};

const bg_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прочетете повече`)
};

const ru_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Читать далее`)
};

const uk_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Читати далі`)
};

const ar_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اقرأ المزيد`)
};

const hi_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`और पढ़ें`)
};

const th_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อ่านเพิ่มเติม`)
};

const ja_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続きを読む`)
};

const zh_cn2_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读更多`)
};

const zh_hant1_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閱讀更多`)
};

const ko_offerdetail_reviews_readmore2 = /** @type {(inputs: Offerdetail_Reviews_Readmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 읽기`)
};

/**
* | output |
* | --- |
* | "Read more" |
*
* @param {Offerdetail_Reviews_Readmore2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_readmore2 = /** @type {((inputs?: Offerdetail_Reviews_Readmore2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Readmore2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_readmore2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_readmore2(inputs)
	if (locale === "da") return da_offerdetail_reviews_readmore2(inputs)
	if (locale === "de") return de_offerdetail_reviews_readmore2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_readmore2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_readmore2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_readmore2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_readmore2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_readmore2(inputs)
	if (locale === "it") return it_offerdetail_reviews_readmore2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_readmore2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_readmore2(inputs)
	if (locale === "no") return no_offerdetail_reviews_readmore2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_readmore2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_readmore2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_readmore2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_readmore2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_readmore2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_readmore2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_readmore2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_readmore2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_readmore2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_readmore2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_readmore2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_readmore2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_readmore2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_readmore2(inputs)
	if (locale === "th") return th_offerdetail_reviews_readmore2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_readmore2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_readmore2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_readmore2(inputs)
	return ko_offerdetail_reviews_readmore2(inputs)
});
export { offerdetail_reviews_readmore2 as "offerDetail.reviews.readMore" }